import containerFuild from '../../description/html-snippets/container-fuild.js';
import css from '../css-snippets/section-madam-size-calculator.js';

import {
  defaultSizeChart,
  serializeSizeChart,
  renderBandOptions,
  renderCupOptions,
  renderSizeOptions,
} from '../html-snippets/size-calculator.js';

const contentHtml = `
<div class="calculator-holder" data-attribute="calculator-holder" data-size-chart='${serializeSizeChart(
  defaultSizeChart,
)}'>
  <div class="title-size-chart" data-attribute="title-size-chart">Find your perfect size:</div>
  <div class="inputs-holder">
    <div class="band">
      <select name="band" id="select-band" data-attribute="select-band">${renderBandOptions(
        defaultSizeChart.band,
      )}</select>
    </div>
    <div class="cup">
      <select name="cup" id="select-cup" data-attribute="select-cup">${renderCupOptions(defaultSizeChart.cup)}</select>
    </div>
    <div class="text-equal">=</div>
    <div class="size-calculator">
      <select name="size-calculator" id="size-calculator" data-attribute="size-calculator">${renderSizeOptions(
        defaultSizeChart.result,
      )}</select>
    </div>
  </div>
  <div class="resultes">
    <div class="icon-prefix" data-attribute="icon-prefix">
      <img
        data-attribute="icon-prefix-image"
        src="https://cdn.shopify.com/s/files/1/0882/8112/1104/files/Ontwerp_zonder_titel_48.png?v=1757671009"
        alt=""
      />
    </div>
    <div class="text-resultes" data-attribute="text-resultes">${defaultSizeChart.emptyText}</div>
  </div>
</div>
`;

export default containerFuild(contentHtml, css, {
  topPadding: false,
  bottomPadding: false,
});
